<template>
    <div>
        <table>
            <tr>
                <td>Duration</td>
                <td>
                    <vue-numeric
                        thousand-separator="'"
                        :precision="0"
                        :min="1"
                        :max="59999"
                        currency="s"
                        currency-symbol-position="suffix"
                        v-model="settings.time">
                    </vue-numeric>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>
                    <p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="speed">Speed</p-radio>
                </td>
                <td>
                    <vue-numeric 
                        thousand-separator="'"
                        :disabled="settings.mode !== 'speed'"
                        :precision="0"
                        :min="50"
                        :max="20000"
                        currency="RPM"
                        currency-symbol-position="suffix"
                        v-model="settings.speed">
                    </vue-numeric>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>
                    <p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="gforce">G-Force</p-radio>
                </td>
                <td>
                    <vue-numeric 
                        thousand-separator="'"
                        :disabled="settings.mode !== 'gforce'"
                        :precision="0"
                        :min="50"
                        :max="20000"
                        currency="RCF"
                        currency-symbol-position="suffix"
                        v-model="settings.gforce">
                    </vue-numeric>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Temperature</td>
                <td>
                    <vue-numeric
                        thousand-separator="'"
                        :precision="0"
                        :min="-20"
                        :max="60"
                        currency="°C"
                        currency-symbol-position="suffix"
                        :minus="true"
                        v-model="settings.temperature">
                    </vue-numeric>
                </td>
                <td></td>
                <td></td>
            </tr>
        </table>
    </div>
</template>


<script>
import actionMixin from './action.mixin';

export default {
    mixins: [actionMixin],
    methods: {
    },
    props: [
    ],
    data: function(){return{
        
    }},
    beforeMount: function(){
        Vue.set(this.settings, 'inputTypes', ['ExSample','MiniSample']);

        this.setDefault('speed', 50);
        this.setDefault('gforce', 50);
        this.setDefault('mode', 'speed');
        this.setDefault('time', 1);
        this.setDefault('temperature', 25);
        
        //Vue.set(this.settings, 'outputType', '');
    }
}

</script>

<style>
    
</style>

<style lang="scss" src="./action.scss" scoped>
